// apps/api/src/modules/poi/poi.module.ts
import { FastifyInstance } from 'fastify'
import { POIController } from './poi.controller'
import tilesRoutes from './tiles.routes'

/**
 * Registers the POI module with the Fastify application.
 * @param fastify The Fastify instance.
 */
export async function poiModule(fastify: FastifyInstance) {
  const poiController = new POIController()
  poiController.registerRoutes(fastify)

  // Register tiles routes (authenticated vector tiles proxy)
  await fastify.register(tilesRoutes, { prefix: '/tiles' })
}
